import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState, useContext } from 'react';
import { InventoriesContext } from '../contexts/InventoriesContext';
import SelectAcerBrag from './SelectAcerBrag';

const useStyles = makeStyles(theme => ({
  selectWrapper: {
    marginTop: 4,
    marginBottom: 4,
  },
}));

export const ROLES_TYPES = {
  SUPPLIERS: 'suppliers',
  USERS: 'users',
};

const RoleSelect = ({ value, setValue, showOnly, readOnly, variableWidth }) => {
  const classes = useStyles();
  const [options, setOptions] = useState([]);
  const { getTheRoles } = useContext(InventoriesContext);

  useEffect(() => {
    getTheRoles().then(res => {
      res.forEach(role => (role.name = role.name.toTitleCase()));
      setOptions(showOnly ? res.filter(r => r.supplier === (showOnly === ROLES_TYPES.SUPPLIERS)) : res);
    });
  }, []);

  return (
    <div className={classes.selectWrapper}>
      <SelectAcerBrag
        variableWidth={variableWidth}
        readOnly={readOnly}
        rows={options}
        value={value}
        setValue={setValue}
        selectTitle="Rol"
      />
    </div>
  );
};

export default RoleSelect;
